import React from "react";
import PropTypes from 'prop-types';
import {Grid, Paper, Typography} from "@material-ui/core";
import CurrencyField from "../Fields/CurrencyField";
import TextField from "../Fields/TextField";
import useStyles from "../../styles/styles";
import setDate from '../../utils/setDate';
import convertToCurrency from '../../utils/convertToCurrency';

const LoanResponseInformation = ({loanResponse}) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h4" component="h4" align="left">Affiliate API Response</Typography>
            {loanResponse ? (
                <Paper className={classes.paper}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="Status" value={loanResponse.status || ''}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <TextField label="Response rendered at" value={setDate(loanResponse.responseRendered)}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="Response Time" value={`${loanResponse.responseTime} sec` || ''}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField label="Publisher Timeout?" value={loanResponse.publisherTimeout ? '✓' : '𐄂'}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <CurrencyField label="Billed" value={loanResponse.billed}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <CurrencyField label="Payout" value={loanResponse.payout}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="Campaign" value={loanResponse.campaignId || ''}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField label="Portfolio" value={loanResponse.portfolioId || ''}/>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="Servicer" value={loanResponse.servicerId || ''}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField label="AMP Offer Amount" value={loanResponse.ampOfferAmount ? convertToCurrency(loanResponse.ampOfferAmount) : ''}/>
                        </Grid>
                        <Grid item xs={12} sm={6} md={2}>
                            <TextField label="AMP Offer Expiration" value={loanResponse.ampOfferExpiration ? setDate(loanResponse.ampOfferExpiration) : ''}/>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField label="AMP Offer Token" value={loanResponse.ampOfferToken || ''}/>
                        </Grid>
                    </Grid>
                </Paper>
            ) : null}
        </>
    )
};

LoanResponseInformation.propTypes = {
    loanResponse: PropTypes.shape({
        id: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        createdAt: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        modifiedAt: PropTypes.string,

        status: PropTypes.string,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        responseRendered: PropTypes.string.isRequired,
        responseTime: PropTypes.number.isRequired,
        /** ISO-8601 datetime string to be passed to javascript's [Date] constructor */
        publisherTimeout: PropTypes.bool.isRequired,
        billed: PropTypes.number,
        payout: PropTypes.number,
        redirectUrl: PropTypes.string,
        campaignId: PropTypes.string,
        portfolioId: PropTypes.string,
        servicerId: PropTypes.string,
    }),
};

LoanResponseInformation.defaultProps = {
    loanResponse: {},
};

export default LoanResponseInformation;
